import { Component } from "@angular/core";
import { MatProgressSpinner } from "@angular/material/progress-spinner";

@Component({
    selector: "spinner",
    styles: [".mat-mdc-progress-spinner { margin: 0 auto; }"],
    template: `<mat-spinner role="alert" aria-busy="true" aria-live="assertive"></mat-spinner>`,
    imports: [MatProgressSpinner]
})
export class SpinnerComponent {}
